import { Radio } from 'antd';
import styled from 'styled-components';

export default styled(Radio.Group)`
	// Add your styles here
`;
